import React from 'react';

const Partners = () => {
  const partners = [
    { name: "HP Enterprise", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/enj4txqf_Hewlett_Packard_Enterprise_logo.svg.png" },
    { name: "Dell Technologies", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/vmx99ntr_Dell_Technologies_logo.svg.png" },
    { name: "Lenovo", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/fxwi7cko_Lenovo-Logo-scaled.jpg" },
    { name: "Citrus", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/bke3w3rl_citrus_current_logo.png" },
    { name: "Intel", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/mm2q0com_intel-logo-new.png" },
    { name: "AMD", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/z6ax8alw_amd-logo.png" },
    { name: "NVIDIA", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/06xq64ku_nvidia-logo-vert-blk_thmb.png" },
    { name: "Fortinet", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/l5m754ph_Fortinet-logo-rgb-black-red.png" },
    { name: "Microsoft", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/0u473c8m_microsoft.jpg" },
    { name: "Google", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/5iy5yt2u_new-Google-logo-png-large-size.png" },
    { name: "Synology", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/886id9ld_synology.png" },
    { name: "Amazon AWS", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/d590edqp_aws.png" },
    { name: "QNAP", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/71vncq07_qnap.png" },
    { name: "VMware", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/y60my9g2_vmware.png" },
    { name: "Cisco", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/xa3x9ji8_Cisco-logo.png" },
    { name: "Asus", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/1j0srq8i_Asus.png" },
    { name: "Samsung", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/pohv2tev_samsung.png" },
    { name: "LG", logo: "https://customer-assets.emergentagent.com/job_trayaksh-services/artifacts/w6gx5sp4_LGE_Logo_HeritageRed_Grey_RGB.png" }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-lime-100 rounded-full mb-4">
            <span className="text-lime-700 font-semibold text-sm">Technology Partners</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Authorized Partner For
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Partnered with world's leading technology brands to deliver best-in-class solutions
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100 flex items-center justify-center group"
            >
              <div className="relative w-full h-16 flex items-center justify-center">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-w-full max-h-full object-contain transition-all duration-300 opacity-90 group-hover:opacity-100 group-hover:scale-105"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = `<span class="text-gray-600 font-semibold text-sm">${partner.name}</span>`;
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Additional Partners Text */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 text-lg">
            Also partnered with{' '}
            <span className="font-semibold text-gray-900">
              Citrix, Pure Storage, Zebra
            </span>
            {' '}and many more leading OEMs
          </p>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 bg-gradient-to-r from-cyan-600 to-lime-600 rounded-2xl p-8 md:p-12 text-center text-white shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Transform Your IT Infrastructure?
          </h3>
          <p className="text-lg md:text-xl mb-8 max-w-3xl mx-auto opacity-95">
            Partner with us for enterprise-grade IT solutions backed by 15+ years of expertise 
            and 200+ successful deployments across India.
          </p>
          <button
            onClick={() => {
              const element = document.querySelector('#contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            className="px-10 py-4 bg-white text-cyan-600 font-bold rounded-lg shadow-2xl hover:shadow-white/30 transform hover:scale-110 transition-all duration-300 relative overflow-hidden group"
          >
            <span className="relative z-10">Get In Touch Today</span>
            <span className="absolute inset-0 bg-gradient-to-r from-cyan-100 to-lime-100 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Partners;
